
export function stringIsValidNonWhitespace(s: string | null | undefined): boolean {
  return typeof s === 'string' && s.trim().length > 0
}

export function compareAlphabetically(a: string, b: string): number {
  return a.localeCompare(b)
}
